import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Table from './Table.jsx'
import _ from 'lodash'

class LogComponent extends Component{
  componentDidMount() {
    this.props.fetchData()
  }

  render() {
    if (_.size(this.props.log) > 0) {
      return <div><Table log={this.props.log}></Table></div>
    }
    return <div>Loading</div>
  }
}

LogComponent.propTypes = {
  fetchData: PropTypes.func.isRequired,
  log: PropTypes.object.isRequired,
}

export default LogComponent
